module.exports = __webpack_public_path__ + "img/jiaoxue_discipline_btn.dce30620.png";